import React from 'react';
import { MessageCircle, FileSearch, Target, Play, TrendingUp } from 'lucide-react';

const steps = [
  {
    number: '01',
    icon: MessageCircle,
    title: 'Premier échange',
    description: "Un premier contact téléphonique ou en cabinet pour comprendre vos préoccupations et répondre à vos questions.",
  },
  {
    number: '02',
    icon: FileSearch,
    title: 'Bilan psychomoteur',
    description: 'Une évaluation complète et ludique pour identifier les forces et les axes de travail de votre enfant.',
  },
  {
    number: '03',
    icon: Target,
    title: 'Objectifs personnalisés',
    description: "Définition ensemble des objectifs thérapeutiques adaptés aux besoins et au rythme de votre enfant.",
  },
  {
    number: '04',
    icon: Play,
    title: 'Séances régulières',
    description: 'Des séances hebdomadaires alliant jeu, mouvement et exercices ciblés dans un cadre bienveillant.',
  },
  {
    number: '05',
    icon: TrendingUp,
    title: 'Suivi et évolution',
    description: "Points réguliers avec vous pour adapter l'accompagnement et célébrer les progrès.",
  },
];

export const Method = () => {
  return (
    <section className="section-padding bg-card relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-primary/5 to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto container-padding">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
            <Target className="w-4 h-4" />
            <span>Méthode de travail</span>
          </div>

          <h2 className="font-display text-3xl sm:text-4xl font-semibold text-foreground mb-6">
            Un parcours clair et{' '}
            <span className="text-gradient">rassurant</span>
          </h2>

          <p className="text-lg text-muted-foreground">
            De la première rencontre au suivi régulier, je vous accompagne à chaque étape pour que votre enfant progresse sereinement.
          </p>
        </div>

        {/* Steps Timeline */}
        <div className="relative">
          {/* Connection Line (Desktop) */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-primary/20 to-transparent" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-6">
            {steps.map((step, index) => (
              <div key={index} className="relative group">
                {/* Step Card */}
                <div className="bg-background rounded-2xl p-6 shadow-soft hover:shadow-card transition-all duration-300 h-full flex flex-col">
                  {/* Number Badge */}
                  <div className="absolute -top-3 left-6 px-3 py-1 rounded-full bg-primary text-primary-foreground text-xs font-semibold">
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mb-4 mt-2 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <step.icon className="w-7 h-7" />
                  </div>

                  {/* Content */}
                  <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed flex-1">
                    {step.description}
                  </p>
                </div>

                {/* Arrow (Mobile/Tablet) */}
                {index < steps.length - 1 && (
                  <div className="lg:hidden flex justify-center my-4">
                    <svg className="w-6 h-6 text-primary/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 5v14M19 12l-7 7-7-7" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-muted-foreground mb-4">
            Prêt(e) à commencer ce parcours avec votre enfant ?
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 text-primary font-medium hover:underline underline-offset-4"
          >
            Contactez-moi pour un premier échange
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Method;